import { TagFilterBuckets } from '../AgGridEngagementFlow/flowSpecTriggerTags.util';

export type TagFilterBucketKey = keyof TagFilterBuckets;

export type TagFilterRow = {
    id: number;
    bucket: TagFilterBucketKey | '';
    tagIds: string[];
};

export const TAG_FILTER_TYPE_DROPDOWN = [
    { id: 1, value: 'Includes Any', bucket: 'any' as TagFilterBucketKey },
    { id: 2, value: 'Includes All', bucket: 'all' as TagFilterBucketKey },
    { id: 3, value: 'Unless Has', bucket: 'not' as TagFilterBucketKey },
];

export function bucketToDropdownValue(bucket: TagFilterBucketKey | ''): string {
    if (!bucket) {
        return '';
    }
    return TAG_FILTER_TYPE_DROPDOWN.find((item) => item.bucket === bucket)?.value ?? '';
}

export function dropdownValueToBucket(value: string): TagFilterBucketKey | '' {
    return TAG_FILTER_TYPE_DROPDOWN.find((item) => item.value === value)?.bucket ?? '';
}

export function bucketsToRows(buckets: TagFilterBuckets): TagFilterRow[] {
    const rows: TagFilterRow[] = [];
    let id = 1;

    (['any', 'all', 'not'] as TagFilterBucketKey[]).forEach((bucket) => {
        if (buckets[bucket].length > 0) {
            rows.push({ id: id++, bucket, tagIds: [...buckets[bucket]] });
        }
    });

    return rows;
}

const BUCKET_CAPTION_ORDER: TagFilterBucketKey[] = ['any', 'all', 'not'];

export type TagFilterCaptionGroup = {
    filterLabel: string;
    tagNames: string[];
};

export function buildGroupedTagFilterCaptionGroups(
    rows: TagFilterRow[],
    tagSpecIdToName: Record<string, string>,
): TagFilterCaptionGroup[] {
    const groups: TagFilterCaptionGroup[] = [];

    for (const bucket of BUCKET_CAPTION_ORDER) {
        const tagIds = rows.filter((row) => row.bucket === bucket).flatMap((row) => row.tagIds);
        if (tagIds.length === 0) {
            continue;
        }

        const uniqueIds = Array.from(new Set(tagIds));
        groups.push({
            filterLabel: bucketToDropdownValue(bucket),
            tagNames: uniqueIds.map((id) => tagSpecIdToName[id] ?? id),
        });
    }

    return groups;
}

export function rowsToBuckets(rows: TagFilterRow[]): TagFilterBuckets {
    const buckets: TagFilterBuckets = { any: [], all: [], not: [] };

    for (const row of rows) {
        if (row.bucket) {
            buckets[row.bucket] = [...row.tagIds];
        }
    }

    return buckets;
}
